import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';
import { type ButtonVariant } from './UiButton.vue';

interface Props {
  value: string | null;
  hint?: string | null;
  dark?: boolean;
  buttonVariant?: ButtonVariant;
  initialFocus?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiSearchForm',
  props: {
    value: { default: null },
    hint: { default: null },
    dark: { type: Boolean, default: false },
    buttonVariant: { default: 'red' },
    initialFocus: { type: Boolean, default: false }
  },
  emits: ["input", "search"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: string | null): void;
  (e: 'search', data: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | null, hint: string | null, dark: boolean, buttonVariant: ButtonVariant, initialFocus: boolean };





const searchTextLocal = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const search = () => {
  emit('search', searchTextLocal.value);
};

const target = ref();
// TODO: refactor input focus
const focusInput = () => {
  if (!props.initialFocus) return;
  target.value.$refs.input.focus();
};

onMounted(() => {
  focusInput();
});

return { __sfc: true,props, emit, searchTextLocal, search, target, focusInput }
}

})